import { EntityUIState } from '../request/interfaces/entity-ui-state';
import { ListActions } from './list-actions';
import { ListConductorQueryParams } from './navigation-provider';

export abstract class PaginationStrategy<T> {
  isLastPage = false;

  abstract applyAction(action: ListActions, paginationData: T): T;

  abstract getDataFromQueryParams(
    queryParamsPrefix: string,
    queryParams: ListConductorQueryParams,
    paginationData: T
  ): T;

  abstract getQueryParamsFromData(queryParamsPrefix: string, data: T): ListConductorQueryParams;

  abstract getDefaultPaginationData(paginationData?: T): T;

  abstract getNetworkParams(paginationData: T): { [key: string]: unknown };

  abstract isFirstPage(paginationData: T): boolean;

  abstract getListState(filtersLength: number, total: number): EntityUIState;
}
